"use strict";

module.exports = function (column, start, end) {

    var dateFormat = this.dateFormat(column);
    var el = typeof column === 'string' ? $(this.$el).find("#VueTables__" + column + "-filter") : column;

    el.text(start.format(dateFormat) + " - " + end.format(dateFormat));
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/set-datepicker-text.js
// module id = 965
// module chunks = 0